import { render, staticRenderFns } from "./ImageTextCutout.vue?vue&type=template&id=8ec0ec04&scoped=true&"
import script from "./ImageTextCutout.vue?vue&type=script&lang=js&"
export * from "./ImageTextCutout.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextCutout.vue?vue&type=style&index=0&id=8ec0ec04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0ec04",
  null
  
)

export default component.exports